import React from 'react';
import { evaluatePassword, PASSWORD_MIN_CLASSES, PASSWORD_MIN_LENGTH } from '../../constants/passwordPolicy';

const ChecklistItem = ({ passed, label }) => (
  <li className={`d-flex align-items-center gap-1 ${passed ? 'text-success' : 'text-muted'}`}>
    <i className={passed ? 'ri-checkbox-circle-fill' : 'ri-close-circle-line'} />
    <span>{label}</span>
  </li>
);

const PasswordStrengthChecklist = ({ password, t }) => {
  const result = evaluatePassword(password);

  return (
    <div className="mt-2">
      <ul className="list-unstyled mb-1 password-strength-checklist">
        <ChecklistItem
          passed={result.length}
          label={t('password-rule-length', { min: PASSWORD_MIN_LENGTH })}
        />
        <ChecklistItem passed={result.upper} label={t('password-rule-upper')} />
        <ChecklistItem passed={result.lower} label={t('password-rule-lower')} />
        <ChecklistItem passed={result.number} label={t('password-rule-number')} />
        <ChecklistItem passed={result.special} label={t('password-rule-special')} />
        <ChecklistItem passed={result.notCommon} label={t('password-rule-not-common')} />
      </ul>
      <small className="text-muted">{t('password-rule-classes-hint', { min: PASSWORD_MIN_CLASSES })}</small>
    </div>
  );
};

export default PasswordStrengthChecklist;
